document.addEventListener("alpine:init", () => {
    Alpine.data("progressiveAccordionItem", () => ({
        id: null,

        init() {},
    }));
});
